import styled from 'styled-components';

export const StyledHappinessQuiz = styled.div`
  background-color: ${props => props.theme.colors.background.bone};
  padding: ${props => props.theme.spacing(3, 0)};
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing(3)};
  p {
    padding: ${props => props.theme.spacing(0, 4)};
  }
  margin-bottom: ${props => props.theme.spacing(12)};
`;

export const Steps = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  padding: ${props => props.theme.spacing(0, 4)};

  @media ${props => props.theme.mobileL} {
    padding: 0;
  }
  max-width: 600px;
`;

export const SpeechBubble = styled.div`
  ${props => props.theme.typography.label};
  line-height: ${props => props.theme.spacing(3)};
  padding: ${props => props.theme.spacing(3)};
  position: absolute;
  background: ${props => props.theme.colors.background.lightest};
  border-radius: 0.4em;
  width: 100px;
  top: 105px;
  &:after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 100%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: ${props => props.theme.colors.background.lightest};
    border-top: 0;
    margin-left: -10px;
    margin-top: -10px;
  }
`;

export const Step = styled.div`
  color: ${props =>
    props.active ? '#000000' : props.theme.colors.text.tertiary};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.theme.typography.heading4};
  background-color: ${props =>
    props.iconColor
      ? props.theme.colors.get(props.iconColor)
      : props.active
      ? props.theme.colors.get('hero.spinach')
      : '#DCD6C4'};
  height: 48px;
  width: 48px;
  border-radius: 50%;
  color: ${props =>
    props.active ? '#000000' : props.theme.colors.text.tertiary};
  padding-bottom: ${props => props.paddingBottom && props.paddingBottom};
`;
